<template>
  <div class="tugas">
    <div class="header">
      <div @click="$router.back()">
        <back />
      </div>
      <h3>Notulen Baru</h3>
    </div>

    <div class="body">
      <form @submit.prevent="simpan()">
        <div class="form-group">
          <label for="">PIC</label>
          <select v-model="param.id_user">
            <option></option>
            <option
              v-for="(item, index) in users"
              :key="index"
              :value="item.id"
            >
              {{ item.nama }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="">Catatan</label>
          <textarea rows="10" v-model="param.catatan"></textarea>
        </div>

        <div class="btn-group" v-show="$user.access == 'ADMIN' || $user.access == 'NOTULEN'">
          <button type="button" class="btn btn-hapus" @click="hapus()">
            HAPUS
          </button>
          <button type="submit" class="btn" :disabled="loading">
            {{ loading ? "MENYIMPAN..." : "SIMPAN" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import * as api from "../api/Api";

import Loading from "./icons/Loading";
import Back from "./icons/Back.vue";

export default {
  name: "Task",
  components: {
    Back,
    Loading,
  },
  data() {
    return {
      users: this.$store.state.user.data,
      param: {
        id_user: null,
        catatan: null,
      },
      loading: false,
    };
  },
  methods: {
    moment,
    simpan() {
      if (!this.param.id_user) {
        alert("Pilih PIC");
        return;
      }

      if (!this.param.catatan) {
        alert("Input catatan");
        return;
      }

      this.loading = true;
      api
        .post("/v1/kendali_kerja/NotulenController/save", this.param)
        .then((r) => {
          this.loading = false;
          this.$router.back();
        });
    },
    hapus() {
      if (confirm("Hapus notulen?")) {
        api
          .post("/v1/kendali_kerja/NotulenController/delete", this.param)
          .then((r) => {
            this.$router.back();
          });
      }
    },
    load(id) {
      api.get("/v1/kendali_kerja/NotulenController/get?id=" + id).then((r) => {
        this.param = r.data;
      });
    },
  },
  mounted() {
    if (this.$route.params.id > 0) {
      this.load(this.$route.params.id);
    }
  },
};
</script>

<style scoped lang="scss">
.tugas {
  padding: 20px;

  .header {
    position: fixed;
    z-index: 2;
    top: 0;
    left: calc(50% - 240px);
    width: 440px;
    display: flex;
    gap: 10px;
    align-items: center;
    border-bottom: 1px solid #ccc;
    padding: 15px 20px;
    background: #fff;

    @media screen and (max-width: 768px) {
      left: 0;
      width: 100%;
    }

    h3 {
      margin: 0;
    }
    .icon {
      height: 26px;
      display: flex;
      align-items: center;
    }
  }

  .body {
    padding-top: 60px;
    padding-bottom: 100px;
  }

  .btn-group {
    display: flex;
    gap: 10px;
    .btn-hapus {
      background: none;
      border: 1px solid #f00;
      color: #f00;
      &:active {
        background: #eee;
      }
    }
  }
}
.skeleton-wrapper {
  .skeleton {
    min-height: 65px;
    border-radius: 4px;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NotulenForm.vue